import { useCallback, useState } from 'react';

type UseToggle = [boolean, () => void];

//  State-updater
const toggle = (value: boolean): boolean => !value;

/**
 * Very simple hook which manages an isToggled boolean.
 *
 * @param {boolean} [initialToggled] - Initial state of the toggle.
 * @returns {[boolean, () => void]} Hook return tuple with the isToggled and onToggle.
 * @example
 * const MyComponent = () => {
 *   const [isToggled, onToggle] = useToggle(true);
 *   return (
 *     <div>
 *        {isToggled ? '👍' : '👎'}
 *       <button onClick={onToggle}>Toggle</button>
 *     </div>
 *   );
 * };
 */
const useToggle = (initialToggled: boolean = false): UseToggle => {
  const [isToggled, setIsToggled] = useState(initialToggled);
  const onToggle = useCallback(() => setIsToggled(toggle), []);
  return [
    isToggled,
    onToggle,
  ];
};

export default useToggle;
